import React from 'react';
import { Button, Form, FormControl, Modal, InputGroup } from 'react-bootstrap';
import { FaCheck, FaPen, FaTimes } from 'react-icons/fa';

import { IntrashBackend } from './backend';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


export class UserProfilePage extends React.Component {
    constructor(props) {
        super(props);
  
        this.state = {
            loggedInUser: null,
            originalUsername: this.props.user.username,
            username: this.props.user.username,
            password: "****************",
            canEditUsers: this.props.user.canEditUsers,
            canEditMovies: this.props.user.canEditMovies,
            canVoteMovies: this.props.user.canVoteMovies,
            isEditingUsername: false,
            hasEditedUsername: false,
            isEditingPassword: false,
            hasEditedPassword: false,
            showErrorModal: false,
            errorModalText: ""
        };
        
        IntrashBackend.getLoggedInUser().then(u => this.setState({ loggedInUser: u }));
    }
    
    async handleSubmit(e) {
        if (this.state.isEditingUsername) {
            try {
                await IntrashBackend.changeUsername(this.props.user.id, this.state.username);
                this.props.onUsernameChanged(this.state.username);
                this.setState({ originalUsername: this.state.username });
            }
            catch (exc) {
                this.setState({ showErrorModal: true, errorModalText: "An error occurred: " + exc })
            }
            this.setState({ isEditingUsername: false });
        }
        else if (this.state.isEditingPassword) {
            try {
                await IntrashBackend.changePassword(this.props.user.id, this.state.password);
                this.setState({ password: "****************" });
            }
            catch (exc) {
                this.setState({ showErrorModal: true, errorModalText: "An error occurred: " + exc })
            }
            this.setState({ isEditingPassword: false });
        }
        e.preventDefault();
    }

    async handleCancel(e) {
        if (this.state.isEditingUsername) {
            this.setState({ username: this.state.originalUsername, isEditingUsername: false });
        }
        else if (this.state.isEditingPassword) {
            this.setState({ password: "****************", isEditingPassword: false });
        }
        e.preventDefault();
    }

    startEditingUsername(e) {
        this.setState({
            isEditingUsername: true
        });
        e.preventDefault();
    }

    startEditingPassword(e) {
        this.setState({
            isEditingPassword: true
        });
        e.preventDefault();
    }

    async toggleCanEditUsers(e) {
        try {
            const newValue = !this.state.canEditUsers;
            await IntrashBackend.changeCanEditUsers(this.props.user.id, newValue);
            this.setState({ canEditUsers: newValue });
        }
        catch (exc) {
            this.setState({ showErrorModal: true, errorModalText: "An error occurred: " + exc })
        }
        e.preventDefault();
    }

    async toggleCanEditMovies(e) {
        try {
            const newValue = !this.state.canEditMovies;
            await IntrashBackend.changeCanEditMovies(this.props.user.id, newValue);
            this.setState({ canEditMovies: newValue });
        }
        catch (exc) {
            this.setState({ showErrorModal: true, errorModalText: "An error occurred: " + exc })
        }
        e.preventDefault();
    }

    async toggleCanVoteMovies(e) {
        try {
            const newValue = !this.state.canVoteMovies;
            await IntrashBackend.changeCanVoteMovies(this.props.user.id, newValue);
            this.setState({ canVoteMovies: newValue });
        }
        catch (exc) {
            this.setState({ showErrorModal: true, errorModalText: "An error occurred: " + exc })
        }
        e.preventDefault();
    }

    render() {
        const renderEditButton = (disabled, isEditing, onStartEditing) => {
            if (!isEditing) {
                return (
                    <Button disabled={disabled} onClick={(e) => onStartEditing(e)}>
                        <FaPen/>
                    </Button>
                );
            }
        }
        const renderCancelButton = (isEditing) => {
            if (isEditing) {
                return (
                    <Button variant="danger" onClick={(e) => this.handleCancel(e)}>
                        <FaTimes/>
                    </Button>
                );
            }
        }
        const renderSubmitButton = (isEditing, hasEdited) => {
            if (isEditing) {
                return (
                    <Button disabled={!hasEdited || this.state.password === null || this.state.password.length < 5} onClick={(e) => this.handleSubmit(e)}>
                        <FaCheck/>
                    </Button>
                );
            }
        }

        const canEditUserPermissions = () => {
            if (this.state.loggedInUser === null) return false;
            return this.state.loggedInUser.canEditUsers;
        }

        return (
            <>
                <Form onSubmit={(e) => this.handleSubmit(e)}>
                    <Form.Group>
                        <Form.Label>Username</Form.Label>
                        <InputGroup>
                            <FormControl type="text" readOnly={!this.state.isEditingUsername} placeholder={this.state.username}
                                        value={this.state.username} onChange={(e) => this.setState({ username: e.target.value, hasEditedUsername: true })}/>
                            <InputGroup.Append>
                                {renderEditButton(this.state.isEditingPassword, this.state.isEditingUsername, (e) => this.startEditingUsername(e))}
                            </InputGroup.Append>
                            <InputGroup.Append>
                                {renderCancelButton(this.state.isEditingUsername)}
                            </InputGroup.Append>
                            <InputGroup.Append>
                                {renderSubmitButton(this.state.isEditingUsername, this.state.hasEditedUsername)}
                            </InputGroup.Append>
                        </InputGroup>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Password</Form.Label>
                        <InputGroup>
                            <FormControl type="password" readOnly={!this.state.isEditingPassword} placeholder={this.state.password}
                                        value={this.state.password} onChange={(e) => this.setState({ password: e.target.value, hasEditedPassword: true })}/>
                            <InputGroup.Append>
                                {renderEditButton(this.state.isEditingUsername, this.state.isEditingPassword, (e) => this.startEditingPassword(e))}
                            </InputGroup.Append>
                            <InputGroup.Append>
                                {renderCancelButton(this.state.isEditingPassword)}
                            </InputGroup.Append>
                            <InputGroup.Append>
                                {renderSubmitButton(this.state.isEditingPassword, this.state.hasEditedPassword)}
                            </InputGroup.Append>
                        </InputGroup>
                    </Form.Group>
                    <Form.Group>
                        <Form.Check type="checkbox" label="Can Edit Users" disabled={!canEditUserPermissions()}
                                    checked={this.state.canEditUsers} onChange={(e) => this.toggleCanEditUsers(e)}/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Check type="checkbox" label="Can Edit Movies" disabled={!canEditUserPermissions()}
                                    checked={this.state.canEditMovies} onChange={(e) => this.toggleCanEditMovies(e)}/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Check type="checkbox" label="Can Vote Movies" disabled={!canEditUserPermissions()}
                                    checked={this.state.canVoteMovies} onChange={(e) => this.toggleCanVoteMovies(e)}/>
                    </Form.Group>
                </Form>
                <Modal show={this.state.showErrorModal} onHide={() => this.setState({ showErrorModal: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.state.errorModalText}</Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.setState({ showErrorModal: false })}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}